import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { ButtonComponent } from '@shared/components/button/button.component';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-asign-role-action-delete-modal',
  templateUrl: './asign-role-action-delete-modal.component.html',
  standalone: true,
  imports: [
    MatCardModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    ButtonComponent,
    MatDialogClose,
  ],
})
export class AsignRoleActionDeleteModalComponent {
  name!: string;
  code!: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    (this.name = this.data.name), (this.code = this.data.code);
  }

  //TODO: Solicitud de eliminacion a base de datos, enviar ID

  accept() {
    //Petición de eliminacion
    console.log('DELETED ');
  }
}
